/* eslint-disable import/no-default-export */
// eslint-disable-next-line no-restricted-imports
import { featureFlagClient } from 'common/lib/feature-flag-client';
import moment from 'moment';
import React from 'react';

const Auth = require('db/auth');
const ApiPromise = require('network/api-promise');
const CtaJoinBoardBanner = require('views/member/team-boards-cta/index')
  .default;
const trackUe = require('debug/trackUe');

interface BannerProps {
  teamName: string;
  teamBoardsLink: string;
  orgId: string;
  largeBanner: boolean;
}
export class TeamBoardsLinkBanner extends React.Component<BannerProps> {
  state = {
    bannerDismissed: false,
    teamBoardsLinkBannerFlag: featureFlagClient.get(
      'walrus.surface-team-boards-banners',
      false,
    ),
  };

  onFeatureFlagUpdate = (newVal: boolean) => {
    this.setState({ teamBoardsLinkBannerFlag: newVal });
  };

  componentDidMount() {
    featureFlagClient.on(
      'walrus.surface-team-boards-banners',
      this.onFeatureFlagUpdate,
    );

    this.recordDateForBannerDismissal(this.props.orgId);
  }

  componentDidUpdate() {
    this.recordDateForBannerDismissal(this.props.orgId);
  }

  componentWillUnmount() {
    featureFlagClient.off(
      'walrus.surface-team-boards-banners',
      this.onFeatureFlagUpdate,
    );
  }

  dismissTeamBoardsLinkBanner = (
    bannerDismissId: string,
    largeBanner: boolean,
  ) => {
    const dirObj = 'team boards join link banner';
    const method = 'by clicking dismiss in banner';
    const bannerSize = largeBanner ? 'large ' : 'small ';

    Auth.me().dismiss(bannerDismissId);

    this.setState({ bannerDismissed: true });

    trackUe(
      'on boards page',
      'dismisses',
      bannerSize + dirObj,
      '',
      '',
      method,
      { teamId: this.props.orgId },
    );
  };

  getBannerDismissId(orgId: string) {
    const bannerDismissId = `team-boards-join-link-banner-${orgId}`;

    return bannerDismissId;
  }

  getDateFirstSawBanner(orgId: string) {
    const messagesDismissed = Auth.me().get('messagesDismissed') || [];
    const joinBanner = messagesDismissed.find(function(dismissedMessage: {
      name: string;
      lastDismissed: string;
    }) {
      return dismissedMessage.name === `team-join-cta-banner-${orgId}`;
    });

    if (!joinBanner) {
      return null;
    } else {
      return joinBanner.lastDismissed;
    }
  }

  recordDateForBannerDismissal(orgId: string) {
    if (
      this.shouldShowBanner(this.props.orgId) &&
      !this.getDateFirstSawBanner(orgId)
    ) {
      this.setDateFirstSawBanner(orgId);
    }
  }

  setDateFirstSawBanner(orgId: string) {
    return ApiPromise({
      url: '/1/members/me/messagesDismissed',
      type: 'post',
      data: {
        name: `team-join-cta-banner-${orgId}`,
      },
    }).then(
      (data: {
        messagesDismissed: { name: string; dateLastDismissed: number };
      }) => {
        Auth.me().set('messagesDismissed', data.messagesDismissed);
      },
    );
  }

  isTeamJoinBannerExpired(orgId: string) {
    const dateFirstSawBanner = this.getDateFirstSawBanner(orgId);
    let days = 0;
    if (dateFirstSawBanner) {
      days = moment().diff(moment(dateFirstSawBanner), 'days');
    }

    return days > 30;
  }

  shouldShowBanner(orgId: string) {
    if (!this.state.teamBoardsLinkBannerFlag) {
      return false;
    }

    const optimisticallyDismissed = this.state.bannerDismissed;
    const isDismissed = Auth.me().isDismissed(this.getBannerDismissId(orgId));

    if (isDismissed || optimisticallyDismissed) {
      return false;
    }

    const isExpired = this.isTeamJoinBannerExpired(orgId);

    if (!this.props.largeBanner && isExpired) {
      return false;
    }

    return true;
  }

  render() {
    if (!this.shouldShowBanner(this.props.orgId)) {
      return null;
    }

    return (
      <CtaJoinBoardBanner
        teamName={
          <React.Fragment key="teamName">{this.props.teamName}</React.Fragment>
        } //allow React to do escaping; avoid localization double escaping
        teamBoardsLink={this.props.teamBoardsLink}
        largeBanner={this.props.largeBanner}
        onClickLink={() => {
          trackUe(
            'on boards page',
            'clicks',
            this.props.largeBanner
              ? 'large team boards join link banner'
              : 'small team boards join link banner',
            '',
            '',
            'by clicking link in banner',
            {
              teamId: this.props.orgId,
            },
          );
        }}
        onDismiss={this.dismissTeamBoardsLinkBanner.bind(
          this,
          this.getBannerDismissId(this.props.orgId),
          this.props.largeBanner,
        )}
      />
    );
  }
}

export default TeamBoardsLinkBanner;



// WEBPACK FOOTER //
// ./app/scripts/views/board-list/board-list-team-board-link-component.tsx